import { ApolloLink } from '@apollo/client';
import { asyncMap } from '@apollo/client/utilities';

const sleep = (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export function createThrottleLink(milliseconds: number) {
    return new ApolloLink((operation, forward) => {
        return asyncMap(forward(operation), async (response) => {
            await sleep(milliseconds);
            return response;
        });
    });
}
